import { useCallback, useEffect, useRef } from 'react';

import _ from 'lodash';
import md5 from 'md5';

import { forwardLink } from 'utils';

const useStateRestore = props => {
  const key = useRef(
    `restore_${props.restoreKey || md5(_.get(props, 'location.pathname') || '')}`
  );

  const propsRef = useRef();
  propsRef.current = props;

  useEffect(() => {
    const { history, location } = propsRef.current || {};

    if (history && _.get(location, `state.${key.current}`)) {
      history.push(location.pathname, _.omit(location.state, key.current));
    }
  }, []);

  const _forwardLink = useCallback(
    (path, forwardState, restoreState, nested = true) =>
      forwardLink(
        propsRef.current,
        path,
        forwardState,
        { [key.current]: restoreState },
        nested
      ),
    []
  );

  return {
    restoreKey: key.current,
    restoreState: _.get(props, `location.state.${key.current}`),
    forwardLink: _forwardLink,
  };
};

export default useStateRestore;
